module.exports = __webpack_public_path__ + "static/media/ImagingTheMoleculesOfLife.8d1fb66c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ImagingTheMoleculesOfLife.png
// module id = 1484
// module chunks = 0